import { makeAutoObservable, toJS } from 'mobx';

class Report {
  unplainedIsLockedPeriod = false;
  unplainedReportType = null;

  constructor() {
    makeAutoObservable(this);

    this.setIsLockedPeriod = this.setIsLockedPeriod.bind(this);
    this.setReportType = this.setReportType.bind(this);
  }

  setIsLockedPeriod(_isLockedPeriod) {
    this.unplainedIsLockedPeriod = _isLockedPeriod;
  }

  setReportType(_reportType) {
    this.unplainedReportType = _reportType;
  }

  get reportType() {
    return toJS(this.unplainedReportType);
  }

  get isLockedPeriod() {
    return toJS(this.unplainedIsLockedPeriod);
  }
}

const reportStore = new Report();

export default reportStore;
